import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

const rootEl = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// On rend TOUJOURS côté client (createRoot), on n'hydrate PAS le HTML pré-rendu
// par react-snap. react-snap pré-rend via un snapshot Puppeteer du DOM client :
// cela fusionne les nœuds texte adjacents (`Texte : {variable}`) et reformate les
// styles inline (`background-image:url(...)`), si bien que l'hydratation échoue
// systématiquement (React #418 → re-render complet du root #423) sur les pages
// corporate. createRoot évite cette tentative vouée à l'échec : le HTML pré-rendu
// reste servi (SEO crawlers sans JS + FCP rapide), React le remplace au mount.
// ⚠️ Ne pas repasser à hydrateRoot sans avoir d'abord supprimé TOUS les nœuds
// texte adjacents + styles inline des pages pré-rendues (sinon le bug revient).
createRoot(rootEl).render(tree);
